import { request } from "../utils/request.js"


export const user_tourist_login = (pojo, args) => request({
    url: 'user/tourist/login',
    method: 'POST',
    params: pojo,
    ...args
})

export const user_login = (pojo, args) => request({
    url: 'user/login',
    method: 'POST',
    params: pojo,
    ...args
})

export const user_addNew = (pojo, args) => request({
    url: 'user/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage:true,
    ...args
})

export const user_update = (pojo, args) => request({
    url: 'user/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage:true,
    ...args
})

export const user_updatePhoneNumber = (pojo, args) => request({
    url: 'user/updatePhoneNumber',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage:true,
    ...args
})

export const user_updateEmailAddress = (pojo, args) => request({
    url: 'user/updateEmailAddress',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage:true,
    ...args
})

export const user_changePassword = (pojo, args) => request({
    url: 'user/changePassword',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage:true,
    ...args
})

export const user_resetPassword = (targetUserId, args) => request({
    url: 'user/resetPassword',
    method: 'GET',
    params: { targetUserId },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_findPageForManage = (pojo, args) => request({
    url: 'user/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const user_findPageForSelect = (pojo, args) => request({
    url: 'user/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const user_changeFrozenStatus = (id, args) => request({
    url: 'user/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_getCurrentUserInfo = (args) => request({
    url: 'user/getCurrentUserInfo',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const user_findById = (id, args) => request({
    url: 'user/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const user_findVoById = (id, args) => request({
    url: 'user/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/user.js